import {
    BASE_PATH,
    EXCHANGE_GROUP_MEMBER_PATH,
    DASHBOARD_PATH
} from '@constants/routes';
import {isSafeRelativeTarget} from './urlValidation';

const TRANSACTION_PATH_REGEX = /^\/transaction\/([^/?#]+)/;
const GROUP_ID_QUERY_KEY = 'groupId';

export function parseTransactionIdFromTarget(target: string): string | null {
    const match = TRANSACTION_PATH_REGEX.exec(target);
    return match?.[1] || null;
}

export function parseGroupIdFromTarget(target: string): string | null {
    const queryStart = target.indexOf('?');
    if (queryStart === -1) return null;
    const params = new URLSearchParams(target.slice(queryStart + 1));
    return params.get(GROUP_ID_QUERY_KEY);
}

export function getIsGroupExchangeTarget(target?: string | null): boolean {
    if (!target) return false;
    const safeTarget = isSafeRelativeTarget(target);
    if (!safeTarget) return false;
    return !!parseGroupIdFromTarget(safeTarget) && !!parseTransactionIdFromTarget(safeTarget);
}

export function getGroupExchangeUrl(target: string): string | null {
    const safeTarget = isSafeRelativeTarget(target);
    if (!safeTarget) return null;
    const groupId = parseGroupIdFromTarget(safeTarget);
    const transactionId = parseTransactionIdFromTarget(safeTarget);
    if (!groupId || !transactionId) return null;

    const params = new URLSearchParams({transactionId, groupId, target: safeTarget});
    return `${BASE_PATH}${EXCHANGE_GROUP_MEMBER_PATH}?${params.toString()}`;
}

export function getPostAuthRedirectUrl(targetParam?: string | null): string {
    const safeTarget = isSafeRelativeTarget(targetParam || undefined);
    if (!safeTarget) return DASHBOARD_PATH;

    const exchangeUrl = getGroupExchangeUrl(safeTarget);
    return exchangeUrl || safeTarget;
}
